import Vue from 'vue'
import './styles/tailwind.config.css'
import './styles/main.scss'

// Automatically import any components with a main.js in it
const f = require.context('./stories', true, /main\.js$/i);
f.keys().forEach(f);

Vue.config.productionTip = false
